import _ from "lodash";

export const isCategoryHidden = (allCategories: string[], category: string) => {
	return _.includes(allCategories, category);
};
